import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ParamsTypeGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const params = route.params;
    const validationRules: Record<
      string,
      { type: string; optional?: boolean }
    > = route.data[`paramValidation`] || {};

    for (const [key, rule] of Object.entries(validationRules)) {
      const value = params[key];

      if (rule.optional && (value === undefined || value === null)) {
        continue;
      }

      if (!this.isValidType(value, rule.type)) {
        console.warn(`Invalid parameter: ${key} should be a ${rule.type}`);
        return this.router.createUrlTree([this.getParentPath(route)]);
      }
    }

    return true;
  }

  private isValidType(value: any, type: string): boolean {
    switch (type) {
      case 'string':
        return typeof value === 'string' && value.trim().length > 0;
      case 'number':
        return !isNaN(Number(value));
      case 'boolean':
        return value === 'true' || value === 'false';
      default:
        return false;
    }
  }

  private getParentPath(route: ActivatedRouteSnapshot): string {
    const pathSegments = route.pathFromRoot
      .flatMap((r) => r.url.map((segment) => segment.path))
      .filter((p) => p);

    pathSegments.pop();
    return '/' + pathSegments.join('/');
  }
}
